'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".ReshopOptIn-module_wrapper__QTuZM{align-items:center;align-self:stretch;background-color:#f7f7f7;border:1px solid #ccc;display:flex;flex-direction:column;gap:1rem;justify-content:center;margin-top:2rem;padding:1.5rem;text-align:center}.ReshopOptIn-module_formField__4lVV7{max-width:312px;text-align:left;width:100%}.ReshopOptIn-module_disclaimer__P28Yw{color:#999;font-style:italic}.ReshopOptIn-module_errorMessage__N2Vdn{padding-top:.5rem}";
var styles = {"wrapper":"ReshopOptIn-module_wrapper__QTuZM","formField":"ReshopOptIn-module_formField__4lVV7","disclaimer":"ReshopOptIn-module_disclaimer__P28Yw","errorMessage":"ReshopOptIn-module_errorMessage__N2Vdn"};
styleInject["default"](css_248z, 'fe139ec9-1b1c-4282-8de3-b712ca6afd3d');

exports["default"] = styles;
